import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';

import * as sha1 from 'js-sha1';

import * as _ from 'lodash'


import { ReponseWebService } from '../datastruct/Meloyi.module';




const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};



@Injectable({
  providedIn: 'root'
})
export class ServicefinService {




   //baseUrl = "https://paiement.hybraine.com/sunupay-sys/" ;

   baseUrl = "https://paysys.hybraine.com/sunupay-sys/" ;


  constructor(private http: HttpClient, private http2: HttpClient) { }


  
  addNewConfig(idUser, config, nomassurance): Promise<any>{   
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, config:config, nomassurance:nomassurance} ;  
	    let backData  : any ;

	    this.remotelogger('http://localhost/Galia/addconfig.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  assignerCourse(idcourse, idusertransport): Promise<any>{  
    return new Promise( (resolve, reject) => {
    	
		let postData = {course: idcourse, chauffeur:idusertransport} ;  

	    let backData  : any ;

	    this.remotelogger('http://144.91.121.43/dieulsima/public/index.php/api/admassignecourse', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  public insertToBd(info:string):Promise<any>{

    return new Promise( (resolve, reject) => {
		
		let postData = {infos: info} ;  

	    let backData  : any ;

        console.log(postData) ;

	    this.remotelogger('http://144.91.121.43/lis/payupload.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});

  }


  getAllPresences(deb, fin): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: 1, datedeb: deb, datefin: fin} ;  
	    let backData  : any ;

        console.log(postData) ;

	    this.remotelogger('http://144.91.121.43/lis/allpresences.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllRetards(deb, fin): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: 1, datedeb: deb, datefin: fin} ;  
	    let backData  : any ;

	    this.remotelogger('http://144.91.121.43/lis/allretards.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllAbsences(deb, fin): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: 1, datedeb: deb, datefin: fin} ;  
	    let backData  : any ;

	    this.remotelogger('http://144.91.121.43/lis/allabsences.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }




  getAllPresencesAggr(deb, fin): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: 1, datedeb: deb, datefin: fin} ;  
	    let backData  : any ;

        console.log(postData) ;

	    this.remotelogger('http://144.91.121.43/lis/allpresencesAggr.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllRetardsAggr(deb, fin): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: 1, datedeb: deb, datefin: fin} ;  
	    let backData  : any ;

	    this.remotelogger('http://144.91.121.43/lis/allretardsAggr.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllAbsencesAggr(deb, fin): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: 1, datedeb: deb, datefin: fin} ;  
	    let backData  : any ;

	    this.remotelogger('http://144.91.121.43/lis/allabsencesAggr.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getAllRunningDemands(): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: 1} ;  
	    let backData  : any ;

	    this.remotelogger('http://144.91.121.43/dieulsima/public/index.php/api/allrunningcourses', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getAllFinishedDemands(): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: 1} ;  
	    let backData  : any ;

	    this.remotelogger('http://144.91.121.43/dieulsima/public/index.php/api/allfinishedcourses', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }




  getAllPartners(samacaabiyoonwii): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
	    let backData  : any ;

	    this.remotelogger(this.baseUrl+'allUsers.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



	makeMagCover(datauri: string): Promise<any>{   
	return new Promise( (resolve, reject) => {

		let postData = { datauri: datauri} ;
	    let backData  : any ;

	    this.remotelogger('https://img.hybraine.com/fileuploader.php', postData ).subscribe(
	        retourPost => {       
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	        	
	            resolve(backData);
	        }
	   	) ;
	});
	}


	getAllCompanies(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'allPoints.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getAllBanks(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'allBanks.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getAllCompagniesPart(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'getCompagniesPart.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}



	getPendingVersement(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'getPendingVersement.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	validerVersement(samacaabiyoonwii: string, opjdhghfd): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii, opjdhghfd: opjdhghfd} ;  
		    let backData  : any ;

		    console.log(postData) ;

		    this.remotelogger(this.baseUrl+'validerVersement.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}



	getServiceSituations(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'allServiceSituations.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}



	getCompagnieSituationsPeriode(samacaabiyoonwii: string, deb, fin, idComp): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii, dateBiniouTambalei:deb, dateBiniouDieekhal:fin, idComp:idComp} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'getCompagnieSituationsPeriode.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getServiceSituationsPeriode(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'allServiceSituationsPeriode.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getAllActifsPoints(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'allActifsPoints.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getAllInactifsPoints(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'allInactifsPoints.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getAllActifsUsers(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'allActifsUsers.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getAllInactifsUsers(samacaabiyoonwii: string): Promise<any>{  
		return new Promise( (resolve, reject) => {
			let postData = {samacaabiyoonwii: samacaabiyoonwii} ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'allInactifsUsers.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}



  getPeriodeSituation(samacaabiyoonwii: string, datedebut: string, datefin: string ): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, dateBiniouTambalei:datedebut, dateBiniouDieekhal:datefin} ;  
	    let backData  : any ;

	    this.remotelogger(this.baseUrl+'situationGlobalPeriode.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getPeriodeSituationForMe(samacaabiyoonwii: string, datedebut: string, datefin: string, kiniousaytou: any ): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii: samacaabiyoonwii, dateBiniouTambalei:datedebut, dateBiniouDieekhal:datefin, kiniousaytou:kiniousaytou} ;  
	    let backData  : any ;

	    this.remotelogger(this.baseUrl+'situationGlobalPeriodeByUser.php', postData ).subscribe(
	        retourPost => {
	          	backData = retourPost ;
	        },
	        response => {

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }


/*
	download(fileName: string) {
	    const options = new RequestOptions({
	        responseType: ResponseContentType.Blob
	    });

	    return this.http.get(this.baseUrl+'rprts', options);
	}
*/


  infosUsers(samacaabiyoonwii, caisse, provider): Promise<any>{  
  	
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii : samacaabiyoonwii,  caisse:caisse, provider:provider} ;  

	    let backData  : any ;

	    console.log(postData) ;

	    this.remotelogger(this.baseUrl+'getInfosUsers.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getAllOps(samacaabiyoonwii,datedeb, datefin): Promise<any>{  
  	
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii : samacaabiyoonwii,  dateBiniouTambalei:datedeb, dateBiniouDieekhal:datefin} ;  

	    let backData  : any ;

	    console.log(postData) ;

	    this.remotelogger(this.baseUrl+'allOpsGlobalPeriode.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getAllOpsToExport(samacaabiyoonwii,datedeb, datefin): Promise<any>{  
  	
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii : samacaabiyoonwii,  dateBiniouTambalei:datedeb, dateBiniouDieekhal:datefin} ;  

	    let backData  : any ;

	    console.log(postData) ;

	    this.remotelogger(this.baseUrl+'allOpsGlobalPeriodeExport.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getAllOpsOfCompagnie(samacaabiyoonwii,datedeb, datefin, nomcompagnie): Promise<any>{  
  	
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii : samacaabiyoonwii,  dateBiniouTambalei:datedeb, dateBiniouDieekhal:datefin, nomcompagnie:nomcompagnie} ;  

	    let backData  : any ;

	    console.log(postData) ;

	    this.remotelogger(this.baseUrl+'getAllOpsOfCompagnie.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  getAllOpsForMe(samacaabiyoonwii,datedeb, datefin, kiniousaytou): Promise<any>{  
  	
    return new Promise( (resolve, reject) => {

		let postData = {samacaabiyoonwii : samacaabiyoonwii,  dateBiniouTambalei:datedeb, dateBiniouDieekhal:datefin, kiniousaytou:kiniousaytou} ;  

	    let backData  : any ;

	    console.log(postData) ;

	    this.remotelogger(this.baseUrl+'allOpsGlobalPeriodebyUser.php', postData ).subscribe(
	        retourPost => {          
			    console.log("THere we are 62") ;
	          	backData = retourPost ;
	          	console.log("*****") ;
	          	console.log(backData) ;
	        },
	        response => {
			    console.log("THere we are 67") ;
			    console.log(response) ;

	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
			    console.log("THere we are 73") ;
	            resolve(backData);
	        }
	   	) ;
	});
  }



  updateConfig(idUser, config, nomassurance): Promise<any>{   
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, config:config, nomassurance: nomassurance } ;  
	    let backData  : any ;

	    this.remotelogger('http://localhost/Galia/updateconfig.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  updateNomAssurance(idUser, nomassurance, newname, newIntitule): Promise<any>{
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, nomassurance:nomassurance, newname:newname, intitule:newIntitule } ;  
	    let backData  : any ;

	    console.log(postData) ;

	    this.remotelogger('http://localhost/Galia/updatenomass.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  updatePolicy(idUser, nomassurance, policyValue): Promise<any>{
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, nomassurance:nomassurance, policy:policyValue } ;  
	    let backData  : any ;

	    console.log(postData) ;

	    this.remotelogger('http://localhost/Galia/updatePolicy.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  deleteAssurance(idUser, nomassurance): Promise<any>{
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, nomassurance:nomassurance } ;  
	    let backData  : any ;

	    this.remotelogger('http://localhost/Galia/deleteconfig.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  addNewParamPredef(idUser, nomparam, nomFrmt, paramvalues): Promise<any>{   
    return new Promise( (resolve, reject) => {

		let postData = {idUser: idUser, paramvalues: JSON.stringify(paramvalues), nomparam:nomparam, nomFrmt: nomFrmt} ;  
	    let backData  : any ;

	    this.remotelogger('http://localhost/Galia/addparampredf.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  getAllParamsPredef(idUser): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser} ;  
	    let backData  : any ;

	    this.remotelogger('http://localhost/Galia/getPredefparams.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;
	          	console.log(backData) ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  getAllParamRecurrent(idUser, nomFrmtRec): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, nomFrmtRec: nomFrmtRec} ;  
	    let backData  : any ;

	    this.remotelogger('http://localhost/Galia/getRecurrentparams.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;
	          	console.log(backData) ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  createCompanyAndAdmin(idUser, companyName, regionPoint, adressepoint): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, companyName:companyName, regionPoint:regionPoint, adressepoint:adressepoint} ;  
	    let backData  : any ;
	    
	    console.log(postData);

	    this.remotelogger(this.baseUrl+'addPoint.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getDevis(idUser, nomassurance, nomcateg, allgarantie, matricule, duree, params, paramvalues): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, nomAssurance:nomassurance, nomCateg:nomcateg, allgarantie:allgarantie, matricule:matricule, duree:duree, params:params, paramsValues:paramvalues} ;  
	    let backData  : any ;
	    this.remotelogger('http://localhost/Galia/getDevis.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;
	          	console.log(backData) ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	   	
	});
  }

  souscrire(idUser, nomAssurance, nomCateg, alldevis, matricule, duree, infoscar, paramsValues, total, nomclient, prenomclient, telephoneclient): Promise<any>{  
    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, nomAssurance:nomAssurance, nomCateg:nomCateg, alldevis:alldevis, matricule:matricule, duree:duree, infoscar:JSON.stringify(infoscar), paramsValues:paramsValues, total: total, nomclient:nomclient, prenomclient:prenomclient, telephoneclient:telephoneclient} ;  
	    let backData  : any ;

	    console.log(JSON.stringify(postData)) ;

	    this.remotelogger('http://localhost/Galia/souscrire.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;
	          	console.log(backData) ;
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	   	
	});
  }


  getGlobalProductionByDateInterval(idUser, datedeb, datefin): Promise<any>{

		return new Promise( (resolve, reject) => {
			let postData = {idUser: idUser, datedeb: datedeb, datefin: datefin} ;  
		    let backData  : any ;

		    this.remotelogger('http://localhost/Galia/getproductionbydateintervalle.php', postData ).subscribe(
		        retourPost => {          
		          	backData = retourPost ;
		        },
		        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }


  getDetailProdLine(idprod): Promise<any>{
		return new Promise( (resolve, reject) => {
			let postData = {idprod: idprod} ;  
		    let backData  : any ;

		    this.remotelogger('http://localhost/Galia/getDetailProdLine.php', postData ).subscribe(
		        retourPost => {          
		          	backData = retourPost ;
		        },
		        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
		            resolve(backData);
		        }
		   	) ;
		});
  }


  initierVersement(samacaabiyoonwii,  montantVerst, choosenReverseur, paymean, asset, debutperiodevers, finperiodevers, infosup): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, montant:montantVerst, reverseur:choosenReverseur, 
						paymean:paymean, asset:asset, debperiodeversement: debutperiodevers, 
						finperiodeversement: finperiodevers, infosup: infosup  } ;  

	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'initierVersement.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  createUser(samacaabiyoonwii,  prenomUser, nomUser, telephoneUser,  hisRole, lesCompagnies): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, prenom:prenomUser, nom:nomUser, telephone:telephoneUser, hisRole: hisRole, lesCompagnies:lesCompagnies } ;  
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'addUser.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  createCompagniePart(samacaabiyoonwii, nomCompagnie): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, nomCompagnie: nomCompagnie } ;
	    let backData  : any ;
	    	    
	    this.remotelogger(this.baseUrl+'addCompagniePart.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  createBank(samacaabiyoonwii, nomBank): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, nomBank: nomBank } ;
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'addBank.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  createService(samacaabiyoonwii, nomService, idBank, nomBank): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, nomService:nomService, idBank:idBank, nomBank: nomBank } ;
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'addService.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  updateplanning(idUser, prenomUser, nomUser, telephoneUser, companyName, activeDays, pointHours, descenteHours): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser, prenom:prenomUser, nom:nomUser, companyName:companyName, telephone:telephoneUser, activeDays:activeDays, pointHours:pointHours, descenteHours:descenteHours } ;  
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger('http://144.91.121.43/lis/updateplanning.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  makeWavePayment(samacaabiyoonwii, montant, numero): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, montant: montant, numero:numero } ;
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'payerwigo.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }

  checkPayStatusWave(samacaabiyoonwii, idwaveop): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idwaveop: idwaveop } ;
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'checkstatutwavepay.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  makeOmPayment(samacaabiyoonwii, montant, numero): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, montant: montant, numero:numero } ;
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'payerwigoom.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  updateUserCompagnie(samacaabiyoonwii, theIduser, compagnies): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, theIduser:theIduser, compagnies:compagnies } ;
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'updateUserCompagnie.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  checkPayStatusOM(samacaabiyoonwii, idwaveop): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idwaveop: idwaveop } ;
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'checkstatutompay.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;        
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  updateMotDePasseUser(samacaabiyoonwii, idUser): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idUser: idUser } ;  
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'reinitializePassword.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;       
	          	console.log(backData) ; 
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


  getuserdetails(samacaabiyoonwii, idUser): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idUser: idUser } ;  
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'getuserdetails.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;       
	          	console.log(backData) ; 
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  reactiverCompte(samacaabiyoonwii, idUser): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idUser: idUser } ;  
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'reactivateUser.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;       
	          	console.log(backData) ; 
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  desactiverCompte(samacaabiyoonwii, idUser): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idUser: idUser } ;  
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger(this.baseUrl+'deactivateUser.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;       
	          	console.log(backData) ; 
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }


	getLastActivityAgence(samacaabiyoonwii: string, idPoint): Promise<any>{  
		return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idPoint: idPoint } ;  
		    let backData  : any ;

		    this.remotelogger(this.baseUrl+'getLastActivityAgence.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}


	getLastActivity(samacaabiyoonwii: string, idUser): Promise<any>{  
		return new Promise( (resolve, reject) => {
		let postData = {samacaabiyoonwii:samacaabiyoonwii, idUser: idUser } ;  
		    let backData  : any ;

		    console.log(postData) ;

		    this.remotelogger(this.baseUrl+'getLastActivity.php', postData ).subscribe(
		        retourPost => {
		          	backData = retourPost ;
		        },
		        response => {

		            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
		        },
		        () => {
				    console.log("THere we are 73") ;
		            resolve(backData);
		        }
		   	) ;
		});
	}



  getUserPlanning(idUser,): Promise<any>{

    return new Promise( (resolve, reject) => {
		let postData = {idUser: idUser } ;  
	    let backData  : any ;
	    
	    console.log(postData) ;
	    
	    this.remotelogger('http://144.91.121.43/lis/getuserplanning.php', postData ).subscribe(
	        retourPost => {          
	          	backData = retourPost ;          
	        },
	        response => {
	            backData = {statutreq: 0, message : "Erreur! Vérifiez votre connexion Internet", data : '', status : true, chauffeurs : []};
	        },
	        () => {
	            resolve(backData);
	        }
	   	) ;
	});
  }



  remotelogger(url: string, sentData: any) {
    return this.http.post<any>(url, sentData, httpOptions);
  }


}
